import * as actionTypes from './actionType';

const axiosPayLoad = {
  userListData: [],
  errorMessages: [],
  gridData: [],
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_USER_LIST_DATA:
      return {
        ...state,
        userListData: action.userListData,
      };
    case actionTypes.SET_ERROR_MESSAGES:
      return { ...state, errorMessages: action.payload };
    case actionTypes.SET_GRID_DATA:
      return { ...state, gridData: action.payload };
    default:
      return state;
  }
};

export default reducer;
